"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFeatures = exports.getFeaturesUrl = exports.hasFeatureType = exports.parseGetFeatureUrl = exports.parseFullFeatureTypeNames = exports.getFeatureTypesFromCapabilities = exports.findAndParseLatLongBoundingBox = exports.getBaseUrl = void 0;
var lodash_1 = require("lodash");
var moment = __importStar(require("moment"));
var xml_utils_1 = require("xml-utils");
var utils_1 = require("../utils");
var ows_1 = require("../ows");
// can be getcapabilities request or anything else
function getBaseUrl(url) {
    var _a = new URL(url), origin = _a.origin, pathname = _a.pathname;
    // remove trailing /
    return origin + pathname.replace(/\/$/, "");
}
exports.getBaseUrl = getBaseUrl;
function findAndParseLatLongBoundingBox(xml) {
    var tag = (0, xml_utils_1.findTagByName)(xml, "LatLongBoundingBox");
    if (!tag) {
        return undefined;
    }
    return [
        Number((0, xml_utils_1.getAttribute)(tag, "minx")),
        Number((0, xml_utils_1.getAttribute)(tag, "miny")),
        Number((0, xml_utils_1.getAttribute)(tag, "maxx")),
        Number((0, xml_utils_1.getAttribute)(tag, "maxy")),
    ];
}
exports.findAndParseLatLongBoundingBox = findAndParseLatLongBoundingBox;
// to-do: MetadataURL
// to-do: parse prefix from name?
function getFeatureTypesFromCapabilities(capabilities) {
    var featureTypes = [];
    (0, xml_utils_1.findTagsByPath)(capabilities, ["FeatureTypeList", "FeatureType"]).forEach(function (featureType) {
        var _a;
        var inner = featureType.inner;
        if (inner) {
            var name_1 = (0, utils_1.findTagText)(inner, "Name");
            if (name_1) {
                // eslint-disable-next-line fp/no-mutating-methods
                featureTypes.push({
                    name: (0, utils_1.parseName)(name_1),
                    abstract: (0, utils_1.findAndParseAbstract)(inner),
                    keywords: (0, ows_1.findAndParseKeywords)(inner),
                    srs: (((_a = (0, utils_1.findTagText)(inner, "DefaultSRS")) === null || _a === void 0 ? void 0 : _a.replace("urn:x-ogc:def:crs:", "")) || (0, utils_1.findTagText)(inner, "SRS")),
                    bbox: ((0, ows_1.findAndParseWGS84BoundingBox)(inner) ||
                        findAndParseLatLongBoundingBox(inner)),
                });
            }
        }
    });
    return featureTypes;
}
exports.getFeatureTypesFromCapabilities = getFeatureTypesFromCapabilities;
function parseFullFeatureTypeNames(capabilities, _a) {
    var _b = _a === void 0 ? { sort: true } : _a, _c = _b.sort, sort = _c === void 0 ? true : _c;
    var names = getFeatureTypesFromCapabilities(capabilities).map(function (featureType) { return featureType.name.full; });
    if (sort) {
        // eslint-disable-next-line fp/no-mutating-methods
        names.sort();
    }
    return names;
}
exports.parseFullFeatureTypeNames = parseFullFeatureTypeNames;
// to-do: find valid prefix for given short name? make async?
function parseGetFeatureUrl(capabilities, _a) {
    var _b = _a === void 0 ? {
        method: "GET",
    } : _a, _c = _b.method, method = _c === void 0 ? "GET" : _c;
    var url = (0, ows_1.findAndParseOperationUrl)(capabilities, "GetFeature", method) ||
        (0, utils_1.findTagAttribute)(capabilities, [
            "Capability",
            "Request",
            "GetFeature",
            "DCPType",
            "HTTP",
            (0, utils_1.titlecase)(method),
        ], "onlineResource");
    if (!url) {
        return undefined;
    }
    // remove params
    return url.split("?")[0];
}
exports.parseGetFeatureUrl = parseGetFeatureUrl;
function hasFeatureType(featureTypes, name, _a) {
    var _b = _a === void 0 ? {
        strict: false,
    } : _a, _c = _b.strict, strict = _c === void 0 ? false : _c;
    return !!featureTypes.find(function (featureType) {
        if (strict) {
            return featureType.name.full === name;
        }
        var parsed = (0, utils_1.parseName)(name);
        return (featureType.name.short === parsed.short &&
            (parsed.namespace
                ? featureType.name.namespace === parsed.namespace
                : true));
    });
}
exports.hasFeatureType = hasFeatureType;
// to-do: validate cql properties based on capabilities.xml
function getFeaturesUrl(capabilities, typeNameOrNames, _a) {
    var _b;
    var _c = _a === void 0 ? {
        bbox: undefined,
        srs: undefined,
        count: undefined,
        dateField: "timestamp",
        dateRange: undefined,
        featureId: undefined,
        format: "geojson",
        method: "POST",
        sortBy: undefined,
        version: "2.0.0",
    } : _a, bbox = _c.bbox, srs = _c.srs, count = _c.count, _d = _c.dateField, dateField = _d === void 0 ? "timestamp" : _d, dateRange = _c.dateRange, featureId = _c.featureId, _e = _c.format, format = _e === void 0 ? "geojson" : _e, _f = _c.method, method = _f === void 0 ? "POST" : _f, sortBy = _c.sortBy, _g = _c.version, version = _g === void 0 ? "2.0.0" : _g;
    var base = parseGetFeatureUrl(capabilities, { method: method });
    if (!base) {
        throw new Error("unable to generate wfs url from capabilities");
    }
    if ((0, lodash_1.isEmpty)(typeNameOrNames) && (0, lodash_1.isEmpty)(featureId)) {
        throw new Error("You must pass in a typeName(s) or featureId");
    }
    return (0, utils_1.formatUrl)(base, (_b = {
            service: "WFS",
            version: version,
            request: "GetFeature"
        },
        _b[/^(0|1)/.test(version)
            ? "typeName"
            : "typeNames"] = typeNameOrNames === null || typeNameOrNames === void 0 ? void 0 : typeNameOrNames.toString(),
        _b.bbox = bbox === null || bbox === void 0 ? void 0 : bbox.toString(),
        _b.featureID = featureId,
        _b.srsName = srs,
        _b[/^(0|1)/.test(version) ? "maxFeatures" : "count"] = [
            null,
            undefined,
            Infinity,
        ].includes(count)
            ? undefined
            : count,
        _b.outputFormat = format === "geojson" ? "json" : format,
        _b.sortBy = sortBy,
        _b.cql_filter = (function () {
            if (dateRange && dateField) {
                var _a = __read(dateRange, 2), startDate = _a[0], endDate = _a[1];
                var startDateFormatted = "".concat(moment
                    .utc(startDate)
                    .format(utils_1.DEFAULT_DATE_FORMAT), "T00:00:00");
                var endDateFormatted = "".concat(moment
                    .utc(endDate)
                    .format(utils_1.DEFAULT_DATE_FORMAT), "T23:59:59");
                return "".concat(dateField, " BETWEEN ").concat(startDateFormatted, " AND ").concat(endDateFormatted);
            }
            return undefined;
        })(),
        _b));
}
exports.getFeaturesUrl = getFeaturesUrl;
function getFeatures(capabilities, typeNameOrNames, _a) {
    if (_a === void 0) { _a = {
        fetch: undefined,
        format: "geojson",
        method: "POST",
        wait: 0,
    }; }
    var _b = _a.fetch, customFetch = _b === void 0 ? fetch : _b, _c = _a.format, format = _c === void 0 ? "geojson" : _c, _d = _a.method, method = _d === void 0 ? "POST" : _d, _e = _a.wait, wait = _e === void 0 ? 0 : _e, rest = __rest(_a, ["fetch", "format", "method", "wait"]);
    return __awaiter(this, void 0, void 0, function () {
        var run;
        var _this = this;
        return __generator(this, function (_f) {
            run = function () { return __awaiter(_this, void 0, void 0, function () {
                var url, response;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            url = getFeaturesUrl(capabilities, typeNameOrNames, __assign({ format: format, method: method }, rest));
                            return [4 /*yield*/, customFetch(url, { method: method })];
                        case 1:
                            response = _a.sent();
                            if (response.status !== 200) {
                                throw new Error("bad response status ".concat(response.status));
                            }
                            if (!["geojson", "xml"].includes(format)) {
                                throw new Error("invalid response format");
                            }
                            if (format === "geojson") {
                                return [2 /*return*/, response.json()];
                            }
                            if (format === "xml") {
                                return [2 /*return*/, response.text()];
                            }
                            return [2 /*return*/, undefined];
                    }
                });
            }); };
            return [2 /*return*/, (0, utils_1.setTimeoutAsync)(wait, run)];
        });
    });
}
exports.getFeatures = getFeatures;
// export async function getLayerDates
